import { useTranslation } from 'react-i18next';

import { AuthLayout } from '@shared/layouts';
import PageContainer from '@shared/components/container/PageContainer';
import { ForgotPasswordForm } from '@features/Auth/Forgot-Password/ui';
import { useForgotPageStyles } from './forgotPage.styles';

export const ForgotPassword = () => {
  const { t } = useTranslation();
  const { classes } = useForgotPageStyles();

  return (
    <PageContainer title={t('formValidation.pageTitles.forgotPassword')} useProductSuffix>
      <AuthLayout className={classes.layout}>
        <div className={classes.root}>
          <ForgotPasswordForm />
        </div>
      </AuthLayout>
    </PageContainer>
  );
};
